interface FloatingMenuDismissOptions {
  target: EventTarget;
  onDismiss: () => void;
  shouldIgnore?: (event: Event) => boolean;
}

const dismissEvents = ["wheel", "touchmove"] as const;

export function listenForFloatingMenuDismiss({
  target,
  onDismiss,
  shouldIgnore = () => false
}: FloatingMenuDismissOptions) {
  const handleDismissGesture = (event: Event) => {
    if (!shouldIgnore(event)) onDismiss();
  };

  for (const eventName of dismissEvents) {
    target.addEventListener(eventName, handleDismissGesture, { capture: true, passive: true });
  }

  return () => {
    for (const eventName of dismissEvents) {
      target.removeEventListener(eventName, handleDismissGesture, { capture: true });
    }
  };
}
